import { useIntl } from 'react-intl';
import { Row, Col } from 'src/componentes/grid';

import useAuth from 'src/hooks/useAuth';
import Input from 'src/componentes/input';
import ContratoLookup from 'src/lookups/ContratoLookup';
import ConvenioLookup from 'src/lookups/ConvenioLookup';
import ProjetoLookup from 'src/lookups/item';
import PlanoContasLookup from 'src/lookups/PlanoContasLookup';
import TipoValorMovimentacaoFinanceiraLookup from 'src/lookups/TipoValorMovimentacaoFinanceiraLookup';
import InputNumber from 'src/componentes/input-number';
import { capitalizeFirstLetter } from 'src/utils/string';
import DatePicker from 'src/componentes/date-picker';
import ArquivoUploadAnexos from 'src/componentes/arquivo-upload/anexos';
import Radio from 'src/componentes/radio';
import EntidadeLookup from 'src/lookups/MovimentacaoFinanceiraEntidadeLookup';

const Geral = ({ model }) => {
  const intl = useIntl();
  const { terms: resources } = useAuth();

  const modelContrato = model.getModel('contrato');
  const modelConvenio = model.getModel('convenio');
  const modelProjeto = model.getModel('projeto');
  const modelPlanoContas = model.getModel('planoContas');
  const modelTipoValor = model.getModel('tipoValor');
  const modelEntidade = model.getModel('entidade');
  const modelNF = model.getModel('nf');
  const modelDataPrevista = model.getModel('dataPrevista');
  const modelDataRealizada = model.getModel('dataRealizada');
  const modelValor = model.getModel('valor');
  const modelTipoMovimentacaoFinanceira = model.getModel(
    'tipoMovimentacaoFinanceira'
  );
  const modelOpcoesTipoMovimentacaoFinanceira = model.getModel(
    'opcoesTipoMovimentacaoFinanceira'
  );
  const modelArquivos = model.getModel('arquivos');

  return (
    <>
      <Row>
        <Col md={12}>
          <Radio
            required
            model={modelTipoMovimentacaoFinanceira}
            options={modelOpcoesTipoMovimentacaoFinanceira.value}
            labelField="descricao"
            name="opcoesTipoMovimentacaoFinanceira"
          />
        </Col>
      </Row>
      {modelTipoMovimentacaoFinanceira &&
        modelTipoMovimentacaoFinanceira.value &&
        modelTipoMovimentacaoFinanceira.value.id == 1 && (
          <Row>
            <Col md={6}>
              <ConvenioLookup
                clearable
                model={{
                  label: intl.formatMessage({ id: 'convenio' }),
                  value: modelConvenio.value,
                  requestChange: modelConvenio.requestChange,
                  errors: modelConvenio.errors,
                }}
                required
              />
            </Col>
          </Row>
        )}
      {modelTipoMovimentacaoFinanceira &&
        modelTipoMovimentacaoFinanceira.value &&
        modelTipoMovimentacaoFinanceira.value.id == 2 && (
          <Row>
            <Col md={6}>
              <ContratoLookup
                clearable
                model={{
                  label: intl.formatMessage({ id: 'contrato' }),
                  value: modelContrato.value,
                  requestChange: modelContrato.requestChange,
                  errors: modelContrato.errors,
                }}
                required
              />
            </Col>
          </Row>
        )}
      {modelTipoMovimentacaoFinanceira &&
        modelTipoMovimentacaoFinanceira.value &&
        modelTipoMovimentacaoFinanceira.value.id == 3 && (
          <Row>
            <Col md={6}>
              <ProjetoLookup
                required
                model={{
                  label: (
                    <span>{capitalizeFirstLetter(resources.projeto)}</span>
                  ),
                  value: modelProjeto.value,
                  requestChange: modelProjeto.requestChange,
                  errors: modelProjeto.errors,
                }}
                data={{ tipoId: 4 }}
              />
            </Col>
          </Row>
        )}
      <Row>
        <Col md={4}>
          <TipoValorMovimentacaoFinanceiraLookup
            model={{
              label: intl.formatMessage({ id: 'tipo' }),
              value: modelTipoValor.value,
              requestChange: modelTipoValor.requestChange,
              errors: modelTipoValor.errors,
            }}
            required
            clearable={false}
          />
        </Col>
        <Col md={6}>
          <PlanoContasLookup
            clearable
            model={{
              label: (
                <span>{capitalizeFirstLetter(resources.planodecontas)}</span>
              ),
              value: modelPlanoContas.value,
              requestChange: modelPlanoContas.requestChange,
              errors: modelPlanoContas.errors,
            }}
          />
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <EntidadeLookup
            clearable
            model={{
              label: intl.formatMessage({ id: 'entidade' }),
              value: modelEntidade.value,
              requestChange: modelEntidade.requestChange,
              errors: modelEntidade.errors,
            }}
          />
        </Col>
        <Col md={4}>
          <Input
            model={{
              label: intl.formatMessage({ id: 'numeroRegistroFiscal' }),
              value: modelNF.value,
              requestChange: modelNF.requestChange,
              errors: modelNF.errors,
            }}
          />
        </Col>
      </Row>
      <Row>
        <Col md={2}>
          <DatePicker
            timeFormat={false}
            autoFormatDate={true}
            model={{
              label: intl.formatMessage({ id: 'label.dataPrevista' }),
              value: modelDataPrevista?.value,
              requestChange: modelDataPrevista.requestChange,
              errors: modelDataPrevista.errors,
            }}
          />
        </Col>
        <Col md={2}>
          <DatePicker
            timeFormat={false}
            autoFormatDate={true}
            model={{
              label: intl.formatMessage({ id: 'label.dataRealizada' }),
              value: modelDataRealizada?.value,
              requestChange: modelDataRealizada.requestChange,
              errors: modelDataRealizada.errors,
            }}
          />
        </Col>
        <Col md={3}>
          <InputNumber
            precision={2}
            model={{
              value: modelValor.value,
              label: intl.formatMessage({ id: 'valor' }),
              requestChange: modelValor.requestChange,
              errors: modelValor.errors,
            }}
            required
          />
        </Col>
        <Col md={2}>
          <ArquivoUploadAnexos tipoAnexo={45} model={modelArquivos} />
        </Col>
      </Row>
    </>
  );
};

export default Geral;
